import { render, staticRenderFns } from "./residents-list.vue?vue&type=template&id=7c2bbb7c&scoped=true"
import script from "./residents-list.vue?vue&type=script&lang=js"
export * from "./residents-list.vue?vue&type=script&lang=js"
import style0 from "./residents-list.vue?vue&type=style&index=0&id=7c2bbb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2bbb7c",
  null
  
)

export default component.exports